__turbopack_context__.v({
  "games": "DiscoverBanner-module__wrapoa__games",
  "image": "DiscoverBanner-module__wrapoa__image",
  "main": "DiscoverBanner-module__wrapoa__main",
  "wrapper": "DiscoverBanner-module__wrapoa__wrapper",
});
